import { Link } from "react-router-dom";
import { Instagram, ArrowUpRight, ArrowRight } from "lucide-react";
import { INSTAGRAM_URL } from "@/lib/site";
import { Reveal, Eyebrow } from "./Reveal";

const PHOTOS = [
  { src: "/photos/grup-ziplama.jpg", alt: "Sürücüler izlerken havada zıplayan enduro sürücüsü", title: "Gökyüzüne doğru", wide: true },
  { src: "/photos/cam-ziplama.jpg", alt: "Çamların önünde zıplayan enduro sürücüsü", title: "Çamların arasında" },
  { src: "/photos/tepe-zirve.jpg", alt: "Tepenin zirvesinde enduro sürücüsü", title: "Zirvede" },
  { src: "/photos/yokus-tirmanis.jpg", alt: "Taşlı yokuşu tırmanan sürücü", title: "Yokuşa meydan oku" },
  { src: "/photos/toz-parkur.jpg", alt: "Tozlu parkurda sürüş", title: "Tozun içinden" },
  { src: "/photos/gun-batimi.jpg", title: "Gün batımında", alt: "Gün batımında tepede enduro sürücüsü" },
  { src: "/photos/inis-toz.jpg", title: "Tozu dumana kat", alt: "Tozlu yokuştan inen enduro sürücüsü" },
  { src: "/photos/profil.jpg", title: "Tam gaz", alt: "Yokuşta yandan görünen enduro sürücüsü" },
  { src: "/photos/arka-tirmanis.jpg", title: "Zirveye son metreler", alt: "Kumlu yokuşu tırmanan enduro sürücüsü" },
  { src: "/photos/ay-yamac.jpg", title: "Mavi gökyüzü altında", alt: "Yamaçta ilerleyen enduro sürücüsü" },
  { src: "/photos/cam-grup.jpg", title: "Çamların gölgesinde", alt: "Çam ormanında motorlarıyla mola veren FX sürücüleri", wide: true },
  { src: "/photos/yan-surus.jpg", title: "Mavi ve toz", alt: "Tozlu parkurda yandan görünen enduro sürücüsü" },
  { src: "/photos/karsidan.jpg", title: "Göz göze", alt: "Parkurda kameraya doğru gelen enduro sürücüsü" },
  { src: "/photos/on-teker.jpg", title: "Ön teker havada", alt: "Ön tekeri havada yokuştan inen sürücü" },
];

const Tile = ({ p, i, hidden }) => (
  <Link
    to="/galeri"
    aria-hidden={hidden || undefined}
    tabIndex={hidden ? -1 : undefined}
    data-testid={hidden ? undefined : `gallery-strip-photo-${i}`}
    className={`group relative block h-[340px] shrink-0 overflow-hidden border border-white/10 md:h-[460px] ${p.wide ? "w-[560px] md:w-[780px]" : "w-[240px] md:w-[320px]"}`}
  >
    <img src={p.src} alt={hidden ? "" : p.alt} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-80 transition-opacity group-hover:opacity-100" />
    <span className="absolute bottom-5 left-5 font-display text-2xl uppercase tracking-wide text-white md:text-3xl">{p.title}</span>
    <span className="absolute right-4 top-4 flex h-10 w-10 translate-y-2 items-center justify-center bg-brand text-white opacity-0 transition-all group-hover:translate-y-0 group-hover:opacity-100"><ArrowUpRight className="h-5 w-5" /></span>
  </Link>
);

export const Gallery = () => (
  <section id="galeri" data-testid="gallery-section" className="overflow-hidden py-24 md:py-32">
    <Reveal className="mx-auto mb-14 flex max-w-7xl flex-col justify-between gap-6 px-5 md:flex-row md:items-end md:px-8">
      <div>
        <Eyebrow>Galeri</Eyebrow>
        <h2 className="font-display text-5xl uppercase leading-none text-white md:text-7xl">Parkurdan kareler.</h2>
      </div>
      <div className="flex flex-wrap gap-3">
        <a href={INSTAGRAM_URL} target="_blank" rel="noopener noreferrer" data-testid="gallery-instagram-link" className="group inline-flex items-center gap-3 border border-white/20 px-6 py-3 font-semibold text-white transition-colors hover:border-white">
          <Instagram className="h-5 w-5" /> @fxmotorsporlari
        </a>
        <Link to="/galeri" data-testid="gallery-all-link" className="group inline-flex items-center gap-3 bg-brand px-6 py-3 font-bold uppercase tracking-wider text-white transition-colors hover:bg-white hover:text-brand">
          Tüm galeri <ArrowRight className="h-5 w-5 transition-transform group-hover:translate-x-1" />
        </Link>
      </div>
    </Reveal>
    <div data-testid="gallery-strip" className="group/strip flex w-max gap-3 animate-[marquee_110s_linear_infinite] hover:[animation-play-state:paused] motion-reduce:animate-none">
      {PHOTOS.map((p, i) => <Tile key={p.src} p={p} i={i} />)}
      {PHOTOS.map((p, i) => <Tile key={`d-${p.src}`} p={p} i={i} hidden />)}
    </div>
  </section>
);
